import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import tagsView from './modules/tagsView'
import permission from './modules/permission'
import settings from './modules/settings'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
	modules: {
		app,
		user,
		tagsView,
		permission,
		settings
	},
	getters,
	state: {
		// 放置初始状态 app启动的时候的全局的初始值
		topNav: 0,
    // 用于处理切换路由取消之前路由的请求
    axiosArr:[]
	},
	mutations: {
		newTopNav(state, topNav) {
			state.topNav = topNav;
		},
    setAxiosArr:({axiosArr},cancelAjax)=>{
		  axiosArr.push(cancelAjax.cancel)
    },
    clearAxiosArr:({axiosArr})=>{
      axiosArr.forEach(item=>{
        let message= '路由跳转取消请求'
        item(message)
      })
      axiosArr = []
    }
	},
  actions:{
	  setAxiosArr:({commit},cancelAjax)=>{
	    commit('SET_AXIOS_ARR',cancelAjax)
    },
    clearAxiosArr:({commit}) => {
	    commit('CLEAR_AXIOS_ARR')
   }
  }
})

export default store
